// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__19pFe","description":"PatientConsentPreview_description__2UdiW"};